import { createContext, useContext, useState } from "react";
import { LoggedUser } from 'BrokerTsLib/src/dtos'
import { useGetGetAppInfoUnreadMessages, useSetReadAppInfoMessage } from "BrokerTsLib/src/hooks/useAppInfoMessage";
import { Product } from "BrokerTsLib/src/enums";

type AuthContextProps = {
    user: LoggedUser | null,
    carkulkaUnreadMessages: number,
    chaloupkaUnreadMessages: number,
    cestovkoUnreadMessages: number,
    login: (user: LoggedUser) => void
    logout: () => void,
    setReadMessage: (msgId: number) => void
    reloadUnreadMessages: Function
}

export const AuthContext = createContext<AuthContextProps | null>(null)

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [user, setUser] = useState<LoggedUser | null>(null);
    const { refetch: refetchCarkulkaMessages, data: carkulkaMessages } = useGetGetAppInfoUnreadMessages(Product.VehicleInsurance);
    const carkulkaUnreadMessages = carkulkaMessages?.data ?? 0
    const { refetch: refetchChaloupkaMessages, data: chaloupkaMessages } = useGetGetAppInfoUnreadMessages(Product.PropertyInsurance);
    const chaloupkaUnreadMessages = chaloupkaMessages?.data ?? 0
    const { refetch: refetchCestovkoMessages, data: cestovkoMessages } = useGetGetAppInfoUnreadMessages(Product.TravelInsurance);
    const cestovkoUnreadMessages = cestovkoMessages?.data ?? 0

    const { mutateAsync: setMessageRead } = useSetReadAppInfoMessage()
    const login = (user: LoggedUser) => setUser(user);
    const logout = () => setUser(null);

    const reloadUnreadMessages = () => { refetchCarkulkaMessages(); refetchChaloupkaMessages(); refetchCestovkoMessages(); }

    const setReadMessage = (msgId: number) => {
        setMessageRead({ id: msgId, read: true }).then(() => reloadUnreadMessages());
    }

    return (
        <AuthContext.Provider value={{
            user,
            carkulkaUnreadMessages,
            chaloupkaUnreadMessages,
            cestovkoUnreadMessages,
            login,
            logout,
            setReadMessage,
            reloadUnreadMessages
        }}>
            {children}
        </AuthContext.Provider >
    );
}

export const useAuth = () => {
    return useContext(AuthContext)
}